import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { ReportSectionDto } from "@/core/features/report-sections/report-section.dto";
import { CreateReportSectionDto } from "@/core/features/report-sections/create-report-section.dto";
import { UpdateReportSectionDto } from "@/core/features/report-sections/update-report-section.dto";

export class ReportSectionsResource extends ResourceBaseService<
  ReportSectionDto,
  CreateReportSectionDto,
  UpdateReportSectionDto
> {
  protected EntityDto = ReportSectionDto;
  protected CreateEntityDto = CreateReportSectionDto;
  protected UpdateEntityDto = UpdateReportSectionDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/report-sections");
  }
}
